import { type ReactNode } from 'react';
import { useModalA11y } from '@/shared/hooks/useModalA11y';

interface DialogShellProps {
  isOpen: boolean;
  onClose: () => void;
  titleId: string;
  overlayClassName: string;
  dialogClassName: string;
  children: ReactNode;
  initialFocusSelector?: string;
}

/**
 * Accessible modal shell: overlay click closes, dialog has role/aria + focus trap.
 */
export function DialogShell({
  isOpen,
  onClose,
  titleId,
  overlayClassName,
  dialogClassName,
  children,
  initialFocusSelector,
}: DialogShellProps) {
  const dialogRef = useModalA11y({ isOpen, onClose, initialFocusSelector });

  if (!isOpen) return null;

  return (
    <div className={overlayClassName} onClick={onClose} role="presentation">
      <div
        ref={dialogRef}
        className={dialogClassName}
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby={titleId}
      >
        {children}
      </div>
    </div>
  );
}
